module.exports = __webpack_public_path__ + "static/wf-cd6ee0501af0a57e680daa8138ec4aad.png";